'use strict';
import angular from 'angular';
import moment from 'moment';

export default class CategoriesController {
  /*@ngInject*/
  constructor($stateParams, $http, $state, $scope, $location, Borne) {
    var vm = this;
    vm.loading = true;
    vm.electron = window.electron;
    window.screen = 'category';
    // vm.categories = []
    if(!Borne.Poste) {
      Borne.load($stateParams.id).then(function () {
        Borne.Poste.Categories = _.filter(Borne.Poste.Categories, 'active');
        /*_(Borne.Poste.Categories).forEach(function(cat){
          vm.cat.titles = cat.titles.split("\n")
        })*/
        vm.borne = Borne.Poste;
        console.log(vm.borne)
        vm.langues = _(vm.borne.availableLanguages).flatMap('dictionnary.main').value();
        vm.loading = false;
        $scope.$apply();
      })
    } else {
      /*_(Borne.Poste.Categories).forEach(function(cat){
        vm.cat.titles = cat.titles.split("\n")
      })*/
      vm.borne = Borne.Poste;
      vm.langues = _(vm.borne.availableLanguages).flatMap('dictionnary.main').value();
      vm.loading = false;
    }
    $('.modal-backdrop').hide();

    if(vm.electron){
    }

    vm.goToLangues = function(){
      $location.path('/borne_langues/' + $stateParams.id);
    }

    vm.selectCategorie = function(categorie){
      vm.selectedCategorie = categorie
      Borne.Poste.selectedCategorie = categorie;
      Borne.Poste.Session.contacts = _.filter(Borne.Poste.contacts, function (contact) {
        return (Borne.Poste.selectedCategorie.contacts.includes(contact._id));
      })
      Borne.Poste.users = Borne.Poste.selectedCategorie.Users;
      _.map(Borne.Poste.Site.Users, function(user){
        if(!_.map(Borne.Poste.users, '_id').includes(user._id) && user.Categories.length == 0) Borne.Poste.users.push(user);
      })
      vm.goToLangues();
    }
  }
}


// WEBPACK FOOTER //
// ./client/app/borne/categories/categories.controller.js